import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { Heart } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function EmptyWishlist() {
  const navigate = useNavigate();
  const controls = useAnimation();

  useEffect(() => {
    controls.start("visible");
  }, [controls]);

  // Animation variants
  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const item = {
    hidden: { y: 15, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { 
        type: "spring", 
        damping: 12,
        stiffness: 100 
      }
    }
  };

  return (
    <motion.div
      className="flex flex-col items-center justify-center h-[60vh] text-center px-4"
      variants={container}
      initial="hidden"
      animate="visible"
    >
      <motion.div
        className="relative mb-6"
        animate={{
          scale: [1, 1.1, 1],
          rotate: [0, 5, -5, 0],
        }}
        transition={{
          repeat: Infinity,
          repeatType: "reverse",
          duration: 2,
          ease: "easeInOut"
        }}
      >
        <Heart 
          size={80} 
          className="text-primary z-10 relative" 
          fill="#FF7236" 
          stroke="none" 
        />
        <div className="absolute inset-0 bg-[#FF7236] rounded-full opacity-10 blur-lg scale-125" />
        <motion.div 
          className="absolute inset-0"
          animate={{
            scale: [1, 1.5, 1],
            opacity: [0.3, 0, 0.3]
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeOut"
          }}
        />
      </motion.div>

      <motion.h2 
        variants={item}
        className="text-3xl font-bold text-text-black mb-3"
      >
        Nothing saved yet
      </motion.h2>
      
      <motion.p 
        variants={item}
        className="text-lg text-gray-600 max-w-md mb-6"
      >
        Found a book you love? Tap the heart icon to add it here and come back anytime.
      </motion.p>

      <motion.button
        variants={item}
        onClick={() => navigate("/explore-books")}
        className="mt-2 px-8 py-3.5 border-2 border-primary rounded-full text-primary font-medium relative overflow-hidden group"
        whileHover={{ 
          scale: 1.05,
          backgroundColor: "#FF7236",
          color: "#fff",
          boxShadow: "0 10px 25px rgba(255, 114, 54, 0.3)"
        }}
        whileTap={{ scale: 0.95 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
      >
        <span className="relative z-10">Explore Books</span>
        <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 transition-opacity rounded-full" />
        <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-0 group-hover:opacity-25 w-[60%] -rotate-[30deg] group-hover:animate-shine" />
      </motion.button>
    </motion.div>
  );
}